// extracted by mini-css-extract-plugin
export default {"support-slider":"support-slider","upper-sec":"upper-sec","info-txt":"info-txt","call-btn":"call-btn","lower-sec":"lower-sec","video-link":"video-link"};